import React, { useState } from 'react';
import { Tag, Icon, Button, Alert } from 'rsuite';
import { auth } from '../../utils/firebase';
import firebase from 'firebase/app';

const ProviderBlock = () => {

    const [isConnected, setConnected] = useState({

        "google.com": auth.currentUser.providerData.some((data) => data.providerId === 'google.com'),
        "github.com": auth.currentUser.providerData.some((data) => data.providerId === 'github.com')
    });

    const updateConnected = (providerID, value) => {
        
        setConnected((current) => {
            
            return {
                ...current,
                [providerID]: value
            }
        })
    }

    // ------------------------------------------------------- //

    const unlink = async (providerID) => {
        
        try {
            
            if(auth.currentUser.providerData.length === 1) {
                throw new Error('You can not unlink from the only provider!')
            }

            await auth.currentUser.unlink(providerID);

            updateConnected(providerID, false);
            Alert.info(`Disconnected from ${providerID}`, 4000);

        } catch (error) {
            Alert.error(error.message, 4000);
        }
    }

    const unlinkGoogle = () => {
        unlink('google.com');
    }

    const unlinkGithub = () => {
        unlink('github.com');
    }

    // ------------------------------------------------------- //

    const link = async (provider) => {
        try {
            
            await auth.currentUser.linkWithPopup(provider);
            Alert.success(`Linked to ${provider.providerId}`, 4000);

            updateConnected(provider.providerId, true);

        } catch (error) {
            Alert.error(error.message);
        }
    }

    const linkGoogle = () => {
        link(new firebase.auth.GoogleAuthProvider());
    }

    const linkGithub = () => {
        link(new firebase.auth.GithubAuthProvider());
    }

    // ------------------------------------------------------- //

    return (
        <div>
            <div className='mt-2'>

                {isConnected['google.com'] &&
                    <Tag closable color='orange' onClose={unlinkGoogle}>
                        <Icon icon='google' /> &nbsp;Connected
                    </Tag>
                }
                
                {isConnected['github.com'] &&
                    <Tag closable onClose={unlinkGithub}>
                        <Icon icon='github' /> &nbsp;Connected
                    </Tag>
                }

            </div>

            <div className='mt-2'>
                
                {!isConnected['google.com'] &&
                    <Button color='orange' block onClick={linkGoogle}>
                        <Icon icon='google'>Link to Google</Icon>
                    </Button>
                }

                {!isConnected['github.com'] &&
                    <Button block onClick={linkGithub}>
                        <Icon icon='github'>Link to GitHub</Icon>
                    </Button>
                }

            </div>
        </div>
    )
}

export default ProviderBlock;
